import ConfirmModal from "../../../components/ConfirmModal";
import {useDispatch, useSelector} from "react-redux";
import {setManageUserModals, tryUpdateUsersState} from "../../../redux/slices/manageUserSlice";
import {USER_STATE_ACTIVE, USER_STATE_CREATED} from "../constants";
import {getFullName} from "../../../helpers/helperFunctions";

const ManageUserConfirmModal = () => {

  const dispatch = useDispatch();
  // const deleting = useSelector((state) => state.dynamicUi.pages.modify.deleting);
  // const { loading: deletingPages} = useSelector((state) => state.dynamicElements.editing);
  const {modal, data} = useSelector((state => state.manageUser.modals.confirm));
  const {
    loading: editing
  } = useSelector((state) => state.dynamicElements.editing);
  const isFeatureAddConfirmation = !!data?.feature;
  const isVerification = !!data?.verify;

  //todo remove created later once the logic is fixed on backend
  const isUserActive = data?.user?.state === USER_STATE_ACTIVE || data?.user?.state === USER_STATE_CREATED;

  const userHasAccessToFeature = () => data.user.features.some((f) => f.id === data.feature.id);

  const onConfirm = () => {

    dispatch(tryUpdateUsersState());

  };


  return (
    <ConfirmModal
      title={isVerification ? "Verify User Manually" : isFeatureAddConfirmation ? `${userHasAccessToFeature() ? "Revoke" : "Add"} Access` : isUserActive ? "Deactivate User" : "Activate User"}
      showModal={modal}
      setShowModal={() => dispatch(setManageUserModals())}
      disabled={editing}
      buttonLabel={isFeatureAddConfirmation || isVerification ? "Confirm" : isUserActive ? "Deactivate" : "Activate"}
      onConfirm={onConfirm}
    >
      {

        isVerification ? <div>
            Manually Verify Users? (Not Recommended)
            <div className="text-sm mt-1"><strong>Note:</strong> Email verification link is sent to every users after creation.</div>
          </div> :

          isFeatureAddConfirmation ?
            <div>
              {
                userHasAccessToFeature() ? <>Revoke access to the "<strong>{data.feature.name}</strong>" feature from
                    the user
                    "<strong>{getFullName(data.user)}</strong>"?</> :
                  <>Give access of "<strong>{data.feature.name}</strong>" feature to the user
                    "<strong>{getFullName(data.user)}</strong>"?</>
              }

            </div>

            :
            <div>Are you sure you want to {isUserActive ? "Deactivate" : "Activate"} <span
              className="font-bold bg-secondary-100 p-1 rounded">{data?.user?.id ? getFullName(data.user) : ""}</span>?
              &nbsp;{isUserActive ? "The user won't be able to login to the system." : "The user will have access to the system."}
            </div>
      }


    </ConfirmModal>
  );
};

export default ManageUserConfirmModal;
